import { Alert, notification } from 'antd'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { InboxOutlined, CloudUploadOutlined, CloseOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { message, Upload } from 'antd';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/UI/Button';
import { uploadBingoGame, uploadGame } from '../../services/pulltabGames';
import { notificationError } from '../../services/notification';
import Loading from '../../components/UI/Loading';
import { useLoading } from '../../context/LoadingProvider/useLoading';
import { sendSystemLog } from '../../context/AuthProvider/useAuth';
const { Dragger } = Upload;

function index(props: {accessLevel: string, type: "bingo" | "game" }) {
  const loading = useLoading()
  const history = useNavigate()
  const [file, setFile] = useState<any | null>(null)
  const [fileUploaded, setFileUploaded] = useState({
    uploaded: false,
    name: '',
  })
  const log = {
    log_type: 'visited',
    log_object: 'upload_game'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, []);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleUploadClick = async () => {
    if (!file) notificationError('No file selected'); 
    loading.addLoading()
    let validUploadResponse = false
    if(props.type === "bingo") validUploadResponse = await uploadBingoGame(file)
    if(props.type === "game") validUploadResponse = await uploadGame(file)
    loading.removeLoading()
    if(validUploadResponse) setFile(null)
  }
  return (
    <div className="upload-pulltab-game">
      {props.type === "game" && (
      <div className="upload-pulltab-game__alert">
        <Alert
          message="Warning"
          description="All existing decks for the uploaded games will be automatically closed"
          type="warning"
          showIcon
          closable
        />
      </div>
      )}
      {file && (
        <div className="upload-pulltab-game__alert">
          <Alert
            message={file?.name|| ''}
            description='The game was selected, click on the Upload button'
            type="success"
            showIcon
            closable
          />
        </div>
      )}

      <div className="upload-pulltab-game__upload">
        <div className="upload-pulltab-game__upload__input">
          {!file && (
            <>
              <label htmlFor="file"><h4>Drag & drop any game</h4> <p>or browse from device</p></label>
              <input name="file" type="file" onChange={handleFileChange} />
              <Button onClick={()=>{}} type="primary"><p>Browse</p></Button>
              <p className="upload-pulltab-game__info">Accepted File Type: .zip</p>
            </>
            
          )}
          {file && (
            <>
              <label htmlFor="file"><h4>{`${file.name}`}</h4> <p>is ready to upload</p></label>
              <div>
                <Button onClick={handleUploadClick} type="primary"><p><CloudUploadOutlined/>  Upload</p></Button>
                <Button onClick={()=> setFile(null)} type="primary"><p><CloseOutlined /> Remove</p></Button>
              </div>
            </>
          )}
          
        </div>
      </div>
      
      <div className="upload-pulltab-game__buttons">
        <Button onClick={() => history(-1)} type='primary'>
          <p id="cancel-button">Return to Game List</p>
        </Button>
      </div>
    </div>
  )
}

export default index